export const PRIVACY_POLICY_URL = process.env.PRIVACY_POLICY_URL
export const TERMS_AND_CONDITIONS_URL = process.env.TERMS_AND_CONDITIONS_URL
export const CARE_CREDIT_URL = process.env.CARE_CREDIT_URL
